<py-modal
  [title]="'product.allVariantsModal_title' | cxTranslate"
  [actions]="templateActions"
  [centered]="true"
  [scrollable]="true"
  [size]="'xl'"
  [blockDismissCoreAction]="true"
  [cxFocus]="focusConfig"
  (scrolledToBottom)="nextScrollIndex()"
  (dismiss)="dismissModal()"
  (esc)="dismissModal()"
>
  <ng-container
    *ngIf="
      {
        articles: articles$ | async,
        filteredArticleRefs: filteredArticleRefs$ | async,
        articleItemQueryParams: articleItemQueryParams$ | async,
        attributes: attributes$ | async
      } as data;
      else loading
    "
  >
    <div *ngIf="product.articlePickerAttributes?.length > 0" class="row">
      <div *ngFor="let attribute of data.attributes || []" class="col-12 col-md-6 col-lg-4 mb-4">
        <py-picker-attribute
          [loading]="!data.articles || !attribute.options"
          [articles]="data.articles"
          [selectedAttributes]="selectedAttributes$ | async"
          [attribute]="attribute"
          [resetable]="product?.articlePickerAttributes?.length > 1"
          (resetValue)="reset()"
          (updateSelectedAttribute)="updateSelectedAttribute($event)"
        ></py-picker-attribute>
      </div>
    </div>

    <div *ngIf="data.filteredArticleRefs; else loading" class="border-top pt-4">
      <py-catalog-article-list
        [showHeader]="false"
        [articleResultRefs]="data.filteredArticleRefs | slice : 0 : pagination.currentScrollIndex"
        [queryParams]="data.articleItemQueryParams"
      ></py-catalog-article-list>
    </div>
  </ng-container>
</py-modal>

<ng-template #templateActions>
  <button
    class="btn btn-secondary"
    [disabled]="!(isUserLoggedIn$ | async)"
    [routerLink]="{ cxRoute: 'cart' } | cxUrl"
    [queryParams]="{ cartType: stockCartType }"
  >
    {{ 'product.allVariantsModal.goToCart_action' | cxTranslate }}
  </button>

  <button
    class="btn btn-primary"
    [disabled]="!(isCheckoutEnabled$ | async)"
    [routerLink]="{ cxRoute: 'checkout' } | cxUrl"
    [queryParams]="{ cartType: stockCartType }"
  >
    {{ 'cart.goToCheckout_action' | cxTranslate }}
  </button>
</ng-template>

<ng-template #loading>
  <div class="d-flex justify-content-center pb-16">
    <cx-spinner></cx-spinner>
  </div>
</ng-template>
